import React from 'react';

import {Button, Text} from '@albert-io/atomic';
import {EmptyIllustration, EmptyState} from 'client/TeacherDashboard/components/EmptyState';
import {history} from 'client/history';

export const OverviewEmptyState = () => (
  <EmptyState
    action={
      <Button roundness='pill' onClick={() => history.pushState(null, '/subjects')}>
        Explore the Library
      </Button>
    }
    illustration={<EmptyIllustration icon='chart-pie' />}
  >
    <div className='gap-x1 flex flex-col'>
      <Text as='div' size='l'>
        No Overview Data
      </Text>
      <Text as='div' className='max-w-[380px]' color='tertiary'>
        Classroom data will appear when students answer questions. Visit the library to assign
        questions.
      </Text>
    </div>
  </EmptyState>
);
